<div class="cf2-documents-card cf2-multiple-card" *ngIf="isReady; else loading">
  <div>
    <ng-container *ngIf="(this.hasReachedDocLimit || dataSub.value.length >=3)  && (this.categoryCode === 'EXPENDITURE')">
      <center>
        <span class="invalid-type-msg">
          Only up to 3 documents can be attached to an expenditure
        </span>
      </center>
    </ng-container>
    <ng-container *ngIf="(dataSvc.documentCountOverLimit() || dataSub.value.length >= DocumentUploadLimit)  && (this.categoryCode === 'CLAIMMGMT')">
      <center>
        <span class="invalid-type-msg">
          Maximum of 3 documents allowed per job in the ESQ
        </span>
      </center>        
    </ng-container>
  </div>
  <div class="action-buttons">
    <ng-container *transloco="let t">
      <!-- Link Documents Button -->
      <cf2-button (callback)="openLinkableModal()" [disabled]="isReadOnly('linkDoc') || dataSub.value.length >= DocumentUploadLimit">{{ t('LINK DOCUMENTS') }}</cf2-button>
      <!-- Add Document Button -->
      <cf2-button (callback)="addDocumentForm()" [disabled]="isReadOnly('addDoc') || dataSub.value.length >= DocumentUploadLimit">{{ t('ADD DOCUMENT') }}</cf2-button> 
    </ng-container>
  </div>

  <div class="list-block flex-row">
    <ng-container *ngIf="dataSub | async as data">
      <cf2-documents-list
        [config]="documentListConfig"
        [isReady]="isReady"
        [caseKey]="caseKey"
        [data]="data"
        [isJobStacked]="isJobStacked"
        [filteredData]="data"
        [isReadOnly]="isReadOnly('addDoc')"
        (selectedDocument)="showEditForm($event)"
        (delete)="canDelete($event)"
      >
      </cf2-documents-list>
    </ng-container>
  </div>
  <div class="edit-block" *ngIf="showDocumentForm">
    <cf2-file-upload-details [fields]="fields" [showSectionCodeField]="showSectionCode">
      <cf2-upload-box
        (fileBlobsUploaded)="addFile($event)"
        [displayName]="displayName"
        [files]="files"
        [date]="docDate"
        [fileType]="fileType"
        [noFiles]="invalidFiles"
      ></cf2-upload-box>

      <!--[noFiles]="invalidFiles"
      [files]="files"-->
    </cf2-file-upload-details>
    <div class="action-buttons">
      <ng-container *transloco="let t">
        <!-- Cancel Button -->
        <cf2-button (callback)="cancelNewDocument()">{{ t('Cancel') }}</cf2-button>
        <!-- Add/Update -->
        <!--<cf2-button *ngIf="!editMode" (callback)="addNewDocument()" 
            [disabled]="isReadOnly('addDoc') || (this.hasReachedDocLimit && dataSub.value.length >=3)">{{ t('Add') }}</cf2-button>-->
        <cf2-button *ngIf="!editMode" (callback)="addNewDocument()" 
            [disabled]="isReadOnly('addDoc') ||  dataSub.value.length >= DocumentUploadLimit">{{ t('Add') }}</cf2-button>
        <cf2-button *ngIf="editMode" [disabled]="!canEdit" (callback)="updateDocument()">{{ t('Update') }}</cf2-button>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="loading">Documents Loading...</div>
</ng-template>